import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

export const initLogRocket = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isDevAxaDomain =
    process.env.REACT_APP_DOMAIN === 'https://dev-axa.sttok.com';

  if (!isDevelopment && !isDevAxaDomain) {
    LogRocket.init(process.env.REACT_APP_LOG_ROCKET_ID, {
      shouldDebugLog: false,
    });

    setupLogRocketReact(LogRocket);
  }
};
